<template>
    <button v-if="compact"
            type="button"
            class="btn"
            :class="buttonClass"
            @click="input?.click()"
            @dragenter="highlight"
            @dragover="highlight"
            @dragleave="unHighlight"
            @drop="onDrop"
    >
        <span class="fas fa-plus me-1"></span>
        {{ buttonLabel }}
        <input type="file" class="d-none" ref="input" multiple :accept="acceptedTypes.join(',')" @change="onFileInputChange" @click.stop>
    </button>
    <label v-else
           class="file-picker-zone card shadow-sm text-center p-5 m-0 d-block form-label"
           :class="{'border-info': highlighted}"
           @dragenter="highlight"
           @dragover="highlight"
           @dragleave="unHighlight"
           @drop="onDrop"
    >
        <span class="fas fa-images fa-2x text-muted mb-3 d-block mx-auto"></span>
        <slot/>
        <input type="file" class="d-none" multiple :accept="acceptedTypes.join(',')" @change="onFileInputChange">
    </label>
</template>

<script lang="ts">
import {defineComponent, PropType, ref} from 'vue';
import {SUPPORTED_IMAGE_TYPES} from '../photos/texts';

/**
 * Picks the files by a click or by dropping them on itself
 */
export default defineComponent({
    props: {
        compact: {type: Boolean, required: true},
        buttonLabel: {type: String, required: true},
        buttonClass: {type: String, required: true},
        acceptedTypes: {type: Array as PropType<string[]>, default: () => SUPPORTED_IMAGE_TYPES},
    },

    emits: ['selected'],

    setup(props, {emit}) {
        const input = ref<HTMLInputElement | null>(null);
        const highlighted = ref(false);

        function highlight(event: DragEvent): void {
            event.preventDefault();
            event.stopPropagation();

            highlighted.value = true;
        }

        function unHighlight(event: DragEvent): void {
            event.preventDefault();
            event.stopPropagation();

            highlighted.value = false;
        }

        function onDrop(event: DragEvent): void {
            unHighlight(event);

            if (event.dataTransfer !== null) {
                emit('selected', [...event.dataTransfer.files]);
            }
        }

        function onFileInputChange(event: Event): void {
            const inputElement = event.target as HTMLInputElement;

            if (inputElement.files !== null) {
                emit('selected', [...inputElement.files]);
            }

            inputElement.value = '';
        }

        return {
            input,
            highlighted,
            highlight,
            unHighlight,
            onDrop,
            onFileInputChange,
        };
    },
});
</script>
